import { getHandoverNoteBody } from './handoverNoteBody';
import { getProgressNoteBody } from './progressNoteBody';

export function countWords(text) {
  if (typeof text !== 'string' || !text.trim()) return 0;
  return text.trim().split(/\s+/).filter(Boolean).length;
}

export function countWordsInNoteJson(noteJson) {
  if (!noteJson || typeof noteJson !== 'object') return 0;
  if (noteJson.note_type === 'progress_note' || noteJson.narrative || noteJson.soap) {
    return countWords(getProgressNoteBody(noteJson));
  }
  if (noteJson.note_type === 'handover' || noteJson.patients || noteJson.sbar) {
    return countWords(getHandoverNoteBody(noteJson));
  }
  if (noteJson.medications_administered?.length || noteJson.medications?.length) {
    const meds = noteJson.medications_administered?.length
      ? noteJson.medications_administered
      : noteJson.medications;
    return meds.reduce((sum, med) => {
      const parts = [
        med?.drug_name,
        med?.dose_amount,
        med?.dose_unit,
        med?.time_given,
        med?.route,
        med?.patient_response,
      ].filter(Boolean);
      return sum + countWords(parts.join(' '));
    }, 0);
  }
  const narrative = noteJson.narrative || '';
  return countWords(typeof narrative === 'string' ? narrative : JSON.stringify(noteJson));
}

export function createPilotMetricsTracker(initialNoteJson, noteGeneratedAt = new Date()) {
  const generatedAt = noteGeneratedAt instanceof Date ? noteGeneratedAt : new Date(noteGeneratedAt);
  return {
    noteGeneratedAt: generatedAt.toISOString(),
    wordsBeforeEdit: countWordsInNoteJson(initialNoteJson),
    editCount: 0,
    wasEdited: false,
    recordEdit() {
      this.editCount += 1;
      this.wasEdited = true;
    },
    buildSavePayload(finalNoteJson) {
      const savedAt = new Date();
      const timeToReviewSeconds = Math.max(
        0,
        Math.round((savedAt.getTime() - generatedAt.getTime()) / 1000)
      );
      return {
        wasEdited: this.wasEdited,
        editCount: this.editCount,
        wordsBeforeEdit: this.wordsBeforeEdit,
        wordsAfterEdit: countWordsInNoteJson(finalNoteJson),
        timeToReviewSeconds,
        noteGeneratedAt: this.noteGeneratedAt,
      };
    },
  };
}
